const actions = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    UPDATE_KEYCLOAK_TOKENS: 'UPDATE_KEYCLOAK_TOKENS',
}

export default actions;